import { withBaseButtonSelect } from "shared/HOC";

const weeks = [];
for (let index = 1; index < 5; index++) {
  weeks.push({ value: `Week ${index}`, label: `Week ${index}` });
}

const SelectWeek = withBaseButtonSelect(weeks);
export default SelectWeek;
